import { NgModule, Type } from '@angular/core';

import { BadgeModule } from '../../atoms/badge/badge.module';
import { CardViewHeaderLinkComponent } from './card-view-header-link.component';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconAttachmentModule } from '../../atoms/icon-attachment/icon-attachment.module';

const components: Type<any>[] = [CardViewHeaderLinkComponent];

@NgModule({
  imports: [
    CommonModule,
    BadgeModule,
    FontAwesomeModule,
    IconAttachmentModule
  ],
  declarations: [components],
  exports: [components],
})
export class CardViewHeaderLinkModule { }
